import { useStore } from '../FronteggStoreContext';
import { useSnapshot } from '../useSnapshot';
const defaultMapper = state => state;
export function useUsersEmailsPolicyState(stateMapper = defaultMapper) {
  const state = useStore().store.auth.userEmailPolicyState;
  return stateMapper(useSnapshot(state));
}
export const useUsersEmailsPolicyActions = () => {
  return useStore().stateActions.auth.usersEmailsPolicyActions;
};